import * as React from "react";
import Dialog from "@mui/material/Dialog";
import "../../components/components/Dialog/SectionDialog.scss";
import "../../components/components/Dialog/SectionName.scss";
import CircleCheckboxM from "../../../components/actions/CircleCheckboxM";
import ButtonJ from "../../components/components/Buttons/Button";

export default function EditIndustryDialog(props) {
  const [success, setSuccess] = React.useState(false);
  const [name, setName] = React.useState(props.IndustryName);

  const handleClose = () => {
    props.closeDialog();
    setTimeout(() => {
      setSuccess(false);
      setName(props.IndustryName);
    }, 150);
  };

  const handleSave = () => {
    props.editIndustry(props.selectedIndustryID, name, () => setSuccess(true));
  };

  return (
    <React.Fragment>
      {props.open && (
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={props.open}
          className={"name_dialog"}
          onClose={handleClose}
        >
          {success ? (
            <>
              <div className={"checkbox_container"}>
                <CircleCheckboxM size="large" checked={true} />
              </div>
              <div className="Label_2">Industry successfully updated</div>
              <ButtonJ
                size="large"
                width="118px"
                padding="0 0 0 0"
                backgroundColor="primary"
                label={"OK"}
                onClick={() => handleClose()}
              />
            </>
          ) : (
            <>
              <div className={"label"}>Update Industry</div>
              <div className={"input_container"}>
                <input
                  className={"input"}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={"Industry name..."}
                />
              </div>
              <div className={"btns_container"}>
                <ButtonJ
                  size="large"
                  width="118px"
                  padding="0 0 0 0"
                  color="black"
                  noElevation={true}
                  onClick={handleClose}
                  label={"Cancel"}
                />
                <ButtonJ
                  size="large"
                  width="118px"
                  padding="0 0 0 0"
                  backgroundColor="primary"
                  label={"Update Industry"}
                  onClick={() => handleSave()}
                />
              </div>
            </>
          )}
        </Dialog>
      )}
    </React.Fragment>
  );
}
